import { Fragment, useState, useEffect } from "react";
import { CircularProgress } from '@material-ui/core';
import { Col, Row } from "reactstrap";
import CheckBlackIcon from "../../../assets/CheckBlackIcon";
import DownloadIconBlue from "../../../assets/DownloadIconBlue";
import ReplayIcon from '@material-ui/icons/Replay';
import WarningRedIcon from "../../../assets/WarningRedIcon";
import './../index.scss'
import ButtonCommon from "../../../components/ButtonCommon";
import CustomAlerts from "../../../components/AlertCustom.js";
import ConfirmationModal from "./ConfirmationModal";
import { getDownloadStatus, downloadGstin, computeCredits, getComputeCreditsStatus, getOfferDetails } from '../../../api/onboarding';

const IsEligible = (props) => {
    const [open, setOpen] = useState(false);
    const [entityList, setEntityList] = useState([]);
    const [currentEntity, setCurrentEntity] = useState({});
    const [dowloadStatus, setDowloadStatus] = useState([]);
    const [tempStatus, setTempStaus] = useState({});
    let statusTimeout, computeStatus;

    useEffect(() => {
      if (props.userState === 'OFFER_GENERATION_IN_PROGRESS') {
        props.setGeneratingOffer(true);
        checkGenerationStatus();
      }
    },[])

    const dowloadGstin = async () => {
      /*let currentDownloadStatus = [...dowloadStatus];
      let index = currentDownloadStatus.findIndex(item => item.taxableEntityId === entity.taxableEntityId);
      currentDownloadStatus[index].status = 'PROCESSING';
      setDowloadStatus(currentDownloadStatus);*/
      let entity = {...currentEntity};
      downlaodGstinData(entity)
      setOpen(false);
    }

    const downlaodGstinData = (entity) => {
      updateTempStatus(entity, true)
      clearTimeout(statusTimeout);
      downloadGstin(entity.taxableEntityId).then(res => {
        let currentDownloadStatus = [...dowloadStatus];
        let index = currentDownloadStatus.findIndex(item => item.taxableEntityId === entity.taxableEntityId);
        currentDownloadStatus[index] = res;
        setDowloadStatus(currentDownloadStatus);
        updateTempStatus(entity, false)
        clearTimeout(statusTimeout);
        statusTimeout = setTimeout(() => {
          fetchDownloadStatus(entityList);
        }, 5000);
      }).catch(error => {
        updateTempStatus(entity, false)
        clearTimeout(statusTimeout);
        statusTimeout = setTimeout(() => {
          fetchDownloadStatus(entityList);
        }, 5000);
        if (error.status === 412) {
          tryDownload(entity)
        }
      })
    }

    const updateTempStatus = (entity, status) => {
      let currentTempStatus = {...tempStatus};
      currentTempStatus[entity.taxableEntityId] = status;
      setTempStaus(currentTempStatus);
    }

    const fetchDownloadStatus = async (entities) => {
      let ids = '';
      await entities.forEach(item => {ids += '&taxableEntityIds='+item.taxableEntityId});
      getDownloadStatus(ids).then(res => {
        let completedGstin = res.filter(gs => gs.status === 'DOWNLOADED');
        setDowloadStatus(res);
        clearTimeout(statusTimeout);
        if (completedGstin.length !== res.length) {
          statusTimeout = setTimeout(() => {
            fetchDownloadStatus(entities || entityList);
          }, 5000);
        }
      }).catch(error => {
        clearTimeout(statusTimeout);
        statusTimeout = setTimeout(() => {
          fetchDownloadStatus(entities || entityList);
        }, 5000);
      })
    }

    useEffect(() => {
      return () => {
        clearTimeout(statusTimeout);
        clearTimeout(computeStatus);
      };
    },[])

    useEffect(() => {
      if (props.gstDetail?.taxableEntityResponses?.length) {
        setEntityList(props.gstDetail.taxableEntityResponses)
        fetchDownloadStatus(props.gstDetail.taxableEntityResponses)  
      }
      
    },[props.gstDetail?.taxableEntityResponses])

    const renderTableData = () => {
      return entityList?.map((val, index) => {
        return (
          <Row className="dataTable" key={index}>
            <Col md={3} xs={3}>
              <p>{val.state}</p>
            </Col>
            <Col md={3} xs={3}>
              <p>{val.gstin}</p>
            </Col>
            <Col md={6} xs={6}>
              {renderDownloadStatus(val)}
            </Col>
          </Row>
        )
      })
    }

    const tryDownload = (entity) => {
      setCurrentEntity(entity)
      setOpen(true)
    }

    const reTryDownload = (entity) => {
      downlaodGstinData(entity)
    }

    const renderDownloadStatus = (val) => {
      let filterStatus = dowloadStatus.find(item => item.taxableEntityId === val.taxableEntityId);
      if (filterStatus ===  'undefined') {
        return
      }
      if (tempStatus[val.taxableEntityId]) {
        return <div className="pending"><CircularProgress size={12} /><span>In progress</span></div>
      }
      switch (filterStatus?.status) {
        case 'NOT_DOWNLOADED':
          return <span onClick={() => tryDownload(val)}><DownloadIconBlue /> Download Now</span>
        case 'PARTIALLY_DOWNLOADED':
          return <span onClick={() => reTryDownload(val)}><DownloadIconBlue /> Download Now</span>
        case 'PROCESSING':
          return <div className="pending"><CircularProgress size={12} /><span>In progress</span></div>
        case "DOWNLOADED":
          return  <span className="success"><CheckBlackIcon /> Downloaded</span>
        case 'CANCELLED':
        case "FAILED":
          return <div className="errorCon"><span className="errored"><WarningRedIcon />Download failed</span> <p onClick={() => reTryDownload(val)}><ReplayIcon style={{ fontSize : 18}} /> Retry Download</p></div> 
        default:
          break;
      }
    }

    const checkGenerationStatus = () => {
      getComputeCreditsStatus().then(res => {
        clearTimeout(computeStatus);
        if (res.asyncJobStatus === 'PROCESSING') {
          computeStatus = setTimeout(() => {
            checkGenerationStatus()
          }, 6000);  
        } else if (res.asyncJobStatus === 'PROCESSED') {
          getOfferDetails().then(res => {
            props.setGeneratingOffer(false);
            if(res.eligible) {
              props.setSection(2);  
            } else {
              props.setStep('notEligible')
            }
          })
        } else {
          props.setGeneratingOffer(false);
          CustomAlerts({
            message : "Loan Generation Failed",
            title:'Error',
            type:'danger'
          })
        }
      }).catch(error => {
        clearTimeout(computeStatus);
        computeStatus = setTimeout(() => {
          checkGenerationStatus()
        }, 6000);
      })
    }

    const generateLoan = () => {
      props.setGeneratingOffer(true);
      computeCredits().then(res => {
        props.setStatus({userState: 'OFFER_GENERATION_IN_PROGRESS'})
        checkGenerationStatus();
      })
    }

    const renderButton = () => {
      let activatedEntity = dowloadStatus.filter(item => item.status === 'DOWNLOADED');

      if (activatedEntity.length === entityList.length) {
        return <Row className="buttonContainer">
          <ButtonCommon title="Generate loan offer" onClick={() => generateLoan()} />
        </Row>
      }
    }

    const renderName = () => {
      let userName = props.userData;
      if (userName && userName?.firstName) {
        return userName?.firstName
      }
    }

    const renderLoadingText = () => {
      let activatedEntity = dowloadStatus.filter(item => item.status === 'PROCESSING');

      if (activatedEntity?.length) {
        return <p className="downloadingText">Downloading might take upto 1 min...</p>
      }
    }

    return (
      <Fragment>
        <div className="checkEligibiltyForm">
          <Col md={12}>
            <h1>{`Congratulations ${renderName()}! You are one step closer to availing your credit line`}</h1>
            <h2>
              To proceed, please download your GST data
            </h2>
            <h2>Please keep your GSTN user name and OTP accessible to download the data</h2>
          </Col>
          <Col md={12} className="tableContainer">
            <Row className="headingTable">
              <Col md={3} xs={3}>
                <p>State</p>
              </Col>
              <Col md={3} xs={3}>
                <p>GSTIN</p>
              </Col>
              <Col md={6} xs={6}>
                <p>Status</p>
              </Col>
            </Row>
            {renderTableData()}
            {renderLoadingText()}
          </Col>
          {renderButton()}
          <ConfirmationModal onConfirm={dowloadGstin} currentEntity={currentEntity} open={open} setCloseModal={() => setOpen(false)}/>
        </div>
      </Fragment>
    )
}

export default IsEligible;